import './src/styles/prism.css';
import './src/styles/global-styles.css';

export const onServiceWorkerUpdateReady = () => window.location.reload(true);

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  if (prevRouterProps?.location?.pathname === routerProps?.location?.pathname) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    return false;
  }

  window.scrollTo({ top: 0, left: 0 });

  return false;
};
